import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import { resendVerificationEmail } from '../services/companyAuthService';
import { useNavigate } from 'react-router-dom';

const RequestVerification = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();


  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email) {
      Swal.fire('Error', 'Please enter your email address', 'error');
      return;
    }

    setIsLoading(true);

    try {
      const response = await resendVerificationEmail(email);
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: response.message,
        timer: 1500,
        showConfirmButton: false
      });
    
      setTimeout(() => {
        navigate('/company/verify-email');
      }, 1500); 
      // Clear the form
      setEmail('');
    } catch (error) {
      console.error('Error requesting verification email:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.message || 'Failed to send verification email'
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center flex-col gap-4 h-[calc(100dvh-80px)] bg-gray-100 px-2 md:px-4 overflow-hidden">
      {/* <h1 className="text-xl sm:text-2xl lg:text-3xl font-bold text-orange-500">
        Infuber
      </h1> */}
      <div className="bg-white p-2 md:p-4 rounded-xl shadow-lg w-full max-w-sm sm:max-w-md lg:max-w-xl">
        <div className="text-center mb-6">
          <h5 className="mt-2 text-gray-700 font-bold text-xs md:text-sm">
            Request Verification Email
          </h5>
          <p className="text-xs md:text-sm text-gray-500">
            Enter your email address to receive a new verification code.
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="space-y-4">
            <div>
              <label className="block text-xs md:text-sm font-medium text-gray-700">
                Email
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                className="mt-1 w-full p-2 border rounded-lg text-sm sm:text-base focus:ring-orange-500 focus:border-orange-500"
                required
              />
            </div>

            <button
              type="submit"
              disabled={isLoading}
              className={`w-full bg-orange-500 text-white py-2 rounded-lg hover:bg-orange-600 transition text-sm sm:text-base flex items-center justify-center font-medium ${
                isLoading ? "opacity-70 cursor-not-allowed" : ""
              }`}
            >
              {isLoading ? (
                <>
                  <svg
                    className="animate-spin h-5 w-5 mr-2 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    />
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8v2a6 6 0 000 12v2a8 8 0 01-8-8z"
                    />
                  </svg>
                  Sending...
                </>
              ) : (
                "Send Verification Email"
              )}
            </button>
          </div>
        </form>

        <div className="mt-4 text-center">
          <Link
            to="/company/login"
            className="inline-flex items-center px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-100 hover:border-gray-400 transition-colors duration-200"
          >
            Back to Login
          </Link>
        </div>
      </div>
    </div>
  );
};

export default RequestVerification; 